import { object, string } from 'yup';

const topic = string().required('Obrigatório');
const paragraphs = string().nullable().optional();

export const smartTextSchema = object({
  topic,
  paragraphs,
});
